var confirmDialog = {};
confirmDialog.template = '<div id="confirmModal" class="modal" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title">{title}</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p>{body}</p></div><div class="modal-footer"><button type="button" class="btn btn-primary">{confirm}</button><button type="button" class="btn btn-secondary" data-dismiss="modal">{cancel}</button></div></div></div></div>';
confirmDialog.defaultText = {
    title: 'Potvrzení',
    body: 'Akce vyžaduje potvrzení. Přejete si pokračovat?',
    confirm: 'Ano',
    cancel: 'Ne'
};
confirmDialog.open = function (target, body, title, confirm, cancel) {

    // vytvoreni noveho modalniho dialogu
    $('#confirmModal').remove();
    var dialogHTML = confirmDialog.template;
    dialogHTML = dialogHTML.replace("{title}", title ? title : confirmDialog.defaultText.title);
    dialogHTML = dialogHTML.replace("{body}", body ? body : confirmDialog.defaultText.body);
    dialogHTML = dialogHTML.replace("{confirm}", confirm ? confirm : confirmDialog.defaultText.confirm);
    dialogHTML = dialogHTML.replace("{cancel}", cancel ? cancel : confirmDialog.defaultText.cancel);
    var dialogElem = $(dialogHTML);

    // callback po potvrzeni
    var confirmCallback = function () {
        $(target).removeAttr('data-waitforconfirm');
        if (target.callback) {
            //  vyvolani ulozene JS funkce
            target.callback();
        } else {
            // puvodni udalost            
            target.click();            
        }          
        $(target).attr('data-waitforconfirm', 'true');
        dialogElem.modal('hide');
    };    

    // nastaveni povrzovaciho tlacitka
    dialogElem.find('.btn-primary').click(confirmCallback);

    // otevreni dialogu
    $('body').append(dialogHTML);
    dialogElem.modal();
};
confirmDialog.initInner = function (selector, body, title, confirm, cancel) {    
    $(selector).not('[data-toggle="modal"]').not('[data-waitforconfirm="true"]').each(function () {     
        
        // zruseni a ulozeni puvodni akce (pokud existuje)
        if (this.onclick) {
            this.callback = this.onclick;   
            this.onclick = null;
        }

        // nastaveni priznaku pro nutnost potvrzeni
        $(this).attr('data-waitforconfirm', 'true');

        $(this).click(function (e) {
            if ($(e.target).attr('data-waitforconfirm')) {

                // vyzaduje potvrzeni
                e.preventDefault();

                // otevreni dialogu
                confirmDialog.open(e.target, body, title, confirm, cancel);               
            }                        
        });
    });   
};
confirmDialog.init = function (selector, body, title, confirm, cancel) {
    $(document).ready(confirmDialog.initInner.bind(this, selector, body, title, confirm, cancel));
    $(document).ajaxComplete(confirmDialog.initInner.bind(this, selector, body, title, confirm, cancel));
};
